/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.product__media button.deferred-media__poster');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.click();
                observer.unobserve(entry.target); // Stop observing after clicking
            }
        });
    }, { threshold: 0.5 }); // Trigger when at least 50% of the button is visible

    buttons.forEach(button => observer.observe(button));

    function convertSizeUnits(context = document) {
      context.querySelectorAll('tr[data-unit="kg"]').forEach(row => {
        row.querySelectorAll('td').forEach(td => {
          if (td.querySelector('.unit-kg')) return; // ✅ Already converted
    
          const text = td.textContent.trim();
          if (/^\d+$/.test(text)) {
            const kg = parseInt(text, 10);
            const lb = Math.round(kg * 2.20462);
            td.innerHTML = `<span class="unit-kg">${kg}</span><span class="unit-lb">${lb}</span>`;
          }
        });
      });
    
      context.querySelectorAll('table[data-unit="cm"] td, th[data-unit="cm"]').forEach(el => {
        if (el.querySelector('.unit-cm')) return; // ✅ Already converted
    
        const text = el.textContent.trim();
        if (/^\d+$/.test(text)) {
          const cm = parseInt(text, 10);
          const inch = Math.round(cm * 0.393701);
          el.innerHTML = `<span class="unit-cm">${cm}</span><span class="unit-in">${inch}</span>`;
        }
      });
    
      updateUnitVisibility(context);
    }
    
    function updateUnitVisibility(context = document) {
      const toggle = context.querySelector('#unitToggle');
      const showImperial = toggle?.checked;
    
      context.querySelectorAll('.unit-cm').forEach(el => {
        el.style.display = showImperial ? 'none' : 'inline-block';
      });
      context.querySelectorAll('.unit-kg').forEach(el => {
        el.style.display = showImperial ? 'none' : 'inline-block';
      });
      context.querySelectorAll('.unit-in').forEach(el => {
        el.style.display = showImperial ? 'inline-block' : 'none';
      });
      context.querySelectorAll('.unit-lb').forEach(el => {
        el.style.display = showImperial ? 'inline-block' : 'none';
      });
    
      // Attach toggle listener if needed
      if (toggle && !toggle.dataset.bound) {
        toggle.addEventListener("change", () => updateUnitVisibility(context));
        toggle.dataset.bound = "true"; // Prevent double-binding
        
      }
    }
    
    convertSizeUnits(document);
  
    // Listen for dynamic modal open
    document.addEventListener("click", function (e) {
      const trigger = e.target.closest('.product-quick-add .swatches-size .radio__legend__link');
    
      if (trigger && trigger.textContent.trim() === "Size Guide") {
        const checkModal = setInterval(() => {
        const modal = trigger.nextElementSibling;

          //console.log('modal: ',modal)
    
          // Ensure modal is fully loaded (has size guide content)
          if (modal && modal.querySelector('.tab-link')) {
            clearInterval(checkModal); // Stop checking once found
    
            // Always run conversion on fresh modal content
            convertSizeUnits(modal);
    
            // Re-bind toggle logic inside modal
            const toggle = modal.querySelector('#unitToggle');
            if (toggle && !toggle.dataset.bound) {
              toggle.addEventListener("change", () => updateUnitVisibility(modal));
              toggle.dataset.bound = "true";
            }
    
            // Re-bind tab switching logic
            modal.querySelectorAll('.tab-link[data-tab]').forEach(link => {

              //console.log('link: ',link)

              link.addEventListener('click', function () {
                //console.log('link click')
                const tabIndex = this.getAttribute('data-tab');
    
                modal.querySelectorAll('.tab-content').forEach(tab => {
                  tab.classList.remove('current');
                });
    
                const targetTab = modal.querySelector(`.tab-content.tab-content-${tabIndex}`);
                if (targetTab) targetTab.classList.add('current');
    
                // Optional: highlight selected tab link
                modal.querySelectorAll('.tab-link').forEach(l => l.classList.remove('current'));
                this.classList.add('current');
              });
            });
          }
        }, 100);
      }
    });

    /* I think this was a attempted bug fix for size guides on mobile
    document.querySelectorAll('.rte__table-wrapper').forEach(wrapper => {
      wrapper.addEventListener('touchstart', () => {
        console.log('trigger 1');
        wrapper.style.overflow = 'hidden';
      });
    
      wrapper.addEventListener('touchend', () => {
        console.log('trigger 2');
        wrapper.style.overflow = 'auto';
      });
    });*/


    /* Product mobile thumb */
    // Function to handle thumbnail click event
    function handleThumbnailClick(event) {
        // Check screen width
        if (window.innerWidth < 749) {
            const mediaId = event.currentTarget.getAttribute("data-media-id");
            const slidesContainer = document.querySelector(".product__slides");
            const targetSlide = document.querySelector(`.product__slide[data-media-id="${mediaId}"]`);

            if (slidesContainer && targetSlide) {
                // Scroll the target slide into view
                slidesContainer.scrollTo({
                    left: targetSlide.offsetLeft,
                    behavior: "smooth"
                });
            }
        }
    }

    // Attach event listeners to all product thumbnail links
    document.querySelectorAll(".product__thumb__link").forEach(thumbnail => {
      thumbnail.addEventListener("click", handleThumbnailClick);
    });

    
    /* Custom Scrolling for size guides */
    const sizeGuideObserver = new MutationObserver(() => {
      const sizeWrappers = document.querySelectorAll('.product__form__outer .rte__table-wrapper:not([data-swipe-initialized])');
    
      sizeWrappers.forEach((sizeWrapper) => {
        //console.log('[sizeGuideObserver] Table wrapper detected');
    
        // Mark as initialized to avoid duplicate listeners
        sizeWrapper.setAttribute('data-swipe-initialized', 'true');
    
        let startX = 0;
        let scrollStart = 0;
        let isTouching = false;
    
        sizeWrapper.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          isTouching = true;
          startX = e.touches[0].clientX;
          scrollStart = sizeWrapper.scrollLeft;
        }, { passive: true });
    
        sizeWrapper.addEventListener('touchmove', (e) => {
          if (!isTouching) return;
          const currentX = e.touches[0].clientX;
          const deltaX = startX - currentX;
          sizeWrapper.scrollLeft = scrollStart + deltaX;
          e.stopPropagation();
        }, { passive: false });
    
        sizeWrapper.addEventListener('touchend', () => {
          isTouching = false;
        });
    
        /*
        sizeWrapper.addEventListener('scroll', () => {
          console.log('scrollLeft:', sizeWrapper.scrollLeft, 'max:', sizeWrapper.scrollWidth - sizeWrapper.clientWidth);
        });
    
        if (sizeWrapper.scrollWidth === sizeWrapper.clientWidth) {
          console.warn('[sizeGuideObserver] No overflow — scroll will feel frozen');
        }
        */
      });
    });
    
    sizeGuideObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });


    //Save last selected variant incase we change colours:
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
      return null;
    }
  

    const sizeRadioOptions = document.querySelectorAll('.selector-wrapper--size .radio__button label');
    //console.log('sizeRadioOptions', sizeRadioOptions)
    sizeRadioOptions.forEach(option => {
      option.addEventListener('click', () => {
        console.log('clicked')
        const input = option.previousElementSibling;
        const value = input?.value;
  
        if (value) {
          document.cookie = `last_variant=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 30}`; // Expires in 30 days
          //console.log(`Saved 'last_variant' cookie: ${value}`);
        }
      });
    });
    
    const sizeSelectOptions = document.querySelectorAll('.selector-wrapper--size .select-popout__option');
    //console.log('sizeSelectOptions', sizeSelectOptions)
    sizeSelectOptions.forEach(option => {
      option.addEventListener('click', () => {
        console.log('clicked')
        const value = option.getAttribute('data-value');
  
        if (value) {
          document.cookie = `last_variant=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 30}`; // Expires in 30 days
          //console.log(`Saved 'last_variant' cookie: ${value}`);
        }
      });
    });

    const lastVariant = getCookie('last_variant');
    if (!lastVariant) return;
  
    const selectWrapper = document.querySelector('.selector-wrapper--size .select__fieldset');
    const swatchWrapper = document.querySelector('.selector-wrapper--size .swatches-size');
  
    if (selectWrapper) {
      const match = selectWrapper.querySelector(`.select-popout__option[data-value="${lastVariant}"]`);
      if (match) {
        match.click();
        //console.log(`Clicked size option (select): ${lastVariant}`);
      }
    } else if (swatchWrapper) {
      const match = swatchWrapper.querySelector(`.radio__button input[value="${lastVariant}"]`);
      if (match) {
        match.click();
        //console.log(`Clicked size option (swatch): ${lastVariant}`);
      }
    }
    
  });

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }


  document.addEventListener('theme:cart:add', async (e) => {
    //console.log('cart:add',e);
  });

  document.addEventListener('theme:product:added', async (e) => {
    const cart = await getCart();
    onCartUpdated(cart, { source: 'product:added', raw: e });
  });

  document.addEventListener('theme:cart:change', async (e) => {
    //console.log('cart:change',e);
  });

  document.addEventListener('theme:cart:update', async (e) => {
    //console.log('cart:update',e);
  });

  function onCartUpdated(cart, ctx) {
    console.log(cart);
    //console.log('window.theme.settings',window.theme.settings)

    // Convert theme setting to an integer in cents
    const free_shipping_limit = Math.round(
      parseFloat(window.theme.settings.free_shipping_limit) * 100
    ) || 0;

    const gwp_product = window.theme.settings.gwp_product;

    if (gwp_product) {
      console.log('gwp 1')
      const variantId = gwp_product.first_variant_id;


      let cart_total_price = cart.total_price;
      let hasGift = false

      for (const item of cart.items || []) {
        if (item.variant_id === variantId) {
          cart_total_price -= item.price;
          hasGift = true
        }
      }

      console.log(cart_total_price)
      console.log(free_shipping_limit)
      console.log(cart_total_price > free_shipping_limit)
      if (cart_total_price > free_shipping_limit && !hasGift) {
        console.log('auto add to cart:', variantId);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            // Optional: mark as a gift so you can detect/remove later if needed
            properties: { _gwp: 'true' }
          })
        })
        .then(r => r.json())
        .then(data => {
          // Optionally trigger a cart refresh or rely on your theme's events
          document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        })
        .catch(err => console.warn('GWP add failed', err));
      }
    }


    // Example: toggle free shipping bar
    // const threshold = 10000; // cents
    // const remaining = Math.max(0, threshold - cart.total_price);
    // ...
  }
})();
